import {Injectable} from "@angular/core";
import {createNetworkInterface, IntrospectionFragmentMatcher, NetworkInterface} from "apollo-client";
// Polyfill fetch
import {SessionActions} from "../actions/session.actions";
import {environment} from "../../../environments/environment";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../redux-store/store";
import {UnauthorizedError} from "../../core/visbos-core/exceptions/unauthorized-error";


@Injectable()
export class GraphqlService {

  constructor() {
  }

  /*
   Midlerware for adding a params field, containing all variables.
   Required by laravel graphql framework, as this expects 'params' instead of 'variables'.
   */
  private phpParams = {
    applyMiddleware(req, next) {
      req.request.params = req.request.variables;
      next();
    }
  };

  public static initFragmentMatcher() {
    let fm = new IntrospectionFragmentMatcher(
      {
        introspectionQueryResultData: {
          __schema: {
            types: [{
              kind: 'INTERFACE',
              name: 'IdentifiableInterface',
              possibleTypes: [{name: 'StockItem'}, {name: 'Stock'}, {name: 'AdministrationUnit'}, {name: 'Vehicle'}]
            }]
          }
        }
      }
    );

    return fm;
  }

  // DI does not work correctly, when trying to inject the GraphQL service dynamically.
  public static initNetworkInterface(ngRedux: NgRedux<IAppState>, sessionActions: SessionActions): NetworkInterface {

    let networkInterface = createNetworkInterface({
      uri: environment.graphqlUrl,
      opts: {
        // Additional fetch options like `credentials` or `headers`
        //credentials: 'same-origin',
        headers: new Headers({'Access-Control-Request-Headers': 'Authorization'})
      }
    });

    // Set global loading variable when sending a query
    let initLoading = {
      applyMiddleware(req, next) {
        if (!ngRedux.getState().session.token) {
          console.warn("No token provided, cancelling request!", [req]);
        } else {
          //sessionActions.initAsyncAction(req);
          next();
        }

      }
    };

    let
      debugHeader = {
        applyMiddleware(req, next) {
          if (!req.options.headers) {
            req.options.headers = {};  // Create the header object if needed.
          }
          req.options.headers.XDEBUG_SESSION = 10269;
          next();
        }
      };

    /*
     Middleware for adding JWT auth token to requests. Token is retrieved from localStorage.
     */
    let
      httpCredentials = {
        applyMiddleware(req, next) {
          if (!req.options.headers) {
            req.options.headers = {};  // Create the header object if needed.
          }
          req.options.headers.authorization = "Bearer " + ngRedux.getState().session.token || null;
          next();
        }
      };

    // Refresh the JWT token for single token requests
    let
      refreshToken = {
        applyAfterware({response}, next) {
          let resp = response;
          let authHeader: string = resp.headers.has('Authorization') ? resp.headers.get('Authorization') : null;
          if (authHeader) {
            let authToken = authHeader.replace("Bearer", "").trim();
            sessionActions.refreshToken(authToken);
          }
          next();
        }
      };

    // End loading when query returns result
    let
      finishLoading = {
        applyAfterware({response}, next) {
          sessionActions.finishAsyncAction(response);
          next();
        }
      };

    let
      unauthorizedQuery = {
        applyAfterware({response}, next) {
          if (response.status === 400 || response.status === 401) {
            if (response.status === 400) {
              sessionActions.logoutUser();
              throw new UnauthorizedError('Unauthorized GraphQL query!', response);
            }
            if (response.status === 401) {
              throw new UnauthorizedError('Authorization token has expired!', response);
            }
          }
          next(); // If not authorized, response is not passed upward

        }
      };

    let
      serverError = {
        applyAfterware({response}, next) {
          if (response.status === 500) {
            console.error('Server returned an error 500!', [response]);
            throw new Error('Server Error');
          }
          next();
        }
      };

    // Add middleware
    let middleware = [httpCredentials];
    /*if (!environment.production) {
     middleware.push(debugHeader);
     }*/

    networkInterface.use(middleware);

    // Add afterware
    networkInterface.useAfter([refreshToken, serverError, unauthorizedQuery]);

    return networkInterface;

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/graphql/graphql.service.ts